import React, { useState } from "react";
import DialogBox from "../../util/DialogBox";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../../../api/auth";

function ForgottenPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();

  /**
   * Récupération de mot de passe via POST /auth/forgot-password.
   * La réponse est générique (anti-énumération) : aucun détail sur
   * l'existence du compte.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { status } = await authApi.forgotPassword({ email });

    DialogBox({
      text:
        status === 200
          ? t("resetPwdMailSend")
          : t("errorSendMail"),
      icon: status === 200 ? "success" : "warning",
      confirmButtonText: "OK",
    });
    navigate("/Connexion");
  };

  return (
    <div className="App">
      <div className="AppContainer d-flex  flex-column align-items-center justify-content-center">
        <div>
          <form onSubmit={handleSubmit} className="accessPage h-100">
            <h6 className="text-center">{t("writeEmail")}</h6>
            <input
              type="email"
              className="form-control mt-3"
              value={email}
              aria-label="Merci de saisir votre adresse mail"
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <div className="d-flex flex-column align-items-center justify-content-center">
              <input
                type="submit"
                value={t("send")}
                className="btnMenu mt-3"
              />
            </div>
          </form>
          <br />
          <div className="d-flex flex-column align-items-center justify-content-center">
            <button
              className="btnBack mt-3"
              onClick={() => navigate("/Connexion")}
            >
              {t("backConnexionPage")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgottenPassword;
